import React from "react";

const RoleFormComponent = ({ roleName, error, handleChange }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className={"mb-1 row"}>
          <div className={"col-sm-2"}>
            <label className="col-form-label"> Role Name </label>
          </div>
          <div className={"col-sm-9"}>
            <input
              className={`form-control ${error ? "is-invalid" : ""}`}
              type={"text"}
              name={"role_name"}
              id={"role_name"}
              value={roleName}
              onChange={handleChange}
              placeholder={"Enter Role Name"}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleFormComponent;
